import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type pyleCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const pyleDocumentTypes = [
  'delivery-photo',
  'proof-of-delivery',
  'research-certificate',
  'signed-bol',
  'weight-and-research-inspection',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const pyle: CarrierDef<pyleCredType> = {
  name: 'A. Duie Pyle',
  scac: 'pyle',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_before_ten_am',
      name: 'Guaranteed before 10am',
      guaranteed: true,
      guaranteedByTime: '10:00',
    },
    {
      id: 'guaranteed_before_twelve_pm',
      name: 'Guaranteed before Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed Day (by 5PM)',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'documents',
    'profinder',
    'tracking',
  ],
  documentTypes: pyleDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
